import React from 'react';
import Icon from './Icon';

export default function ToastContainer({ toasts, removeToast }) {
    if (toasts.length === 0) return null;

    return (
        <div className="fixed bottom-6 right-6 z-[100] flex flex-col gap-2 max-w-md" role="alert" aria-live="polite">
            {toasts.map(t => (
                <div key={t.id} className={`px-4 py-3 rounded-lg shadow-lg border flex items-start gap-3 animate-slide-in ${
                    t.type === 'error' ? 'bg-red-50 border-red-200 text-red-800 dark:bg-red-900/80 dark:border-red-700 dark:text-red-200' :
                    t.type === 'success' ? 'bg-emerald-50 border-emerald-200 text-emerald-800 dark:bg-emerald-900/80 dark:border-emerald-700 dark:text-emerald-200' :
                    'bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-900/80 dark:border-amber-700 dark:text-amber-200'
                }`}>
                    <Icon name={t.type === 'error' ? 'alert-circle' : t.type === 'success' ? 'check-circle-2' : 'alert-triangle'} className="w-5 h-5 flex-shrink-0 mt-0.5" />
                    <p className="text-sm flex-1">{t.message}</p>
                    <button onClick={() => removeToast(t.id)} className="opacity-60 hover:opacity-100 flex-shrink-0">
                        <Icon name="x" className="w-4 h-4" />
                    </button>
                </div>
            ))}
        </div>
    );
}
